/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_zoi_card__arrival__see_accommodation_zone = /** @type {(inputs: {}) => string} */ () => {
	return `Auf der Karte anzeigen`
};

const en_zoi_card__arrival__see_accommodation_zone = /** @type {(inputs: {}) => string} */ () => {
	return `See on the map`
};

const es_zoi_card__arrival__see_accommodation_zone = /** @type {(inputs: {}) => string} */ () => {
	return `Ver en la mapa`
};

const fr_zoi_card__arrival__see_accommodation_zone = /** @type {(inputs: {}) => string} */ () => {
	return `Voir sur la carte`
};

const it_zoi_card__arrival__see_accommodation_zone = /** @type {(inputs: {}) => string} */ () => {
	return `Visualizza sulla mappa`
};

const nl_zoi_card__arrival__see_accommodation_zone = /** @type {(inputs: {}) => string} */ () => {
	return `Bekijken op de kaart`
};

const pt_zoi_card__arrival__see_accommodation_zone = /** @type {(inputs: {}) => string} */ () => {
	return `Ver no mapa`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__arrival__see_accommodation_zone = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.zoi_card__arrival__see_accommodation_zone(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("zoi_card__arrival__see_accommodation_zone", locale)
	if (locale === "de") return de_zoi_card__arrival__see_accommodation_zone(inputs)
	if (locale === "en") return en_zoi_card__arrival__see_accommodation_zone(inputs)
	if (locale === "es") return es_zoi_card__arrival__see_accommodation_zone(inputs)
	if (locale === "fr") return fr_zoi_card__arrival__see_accommodation_zone(inputs)
	if (locale === "it") return it_zoi_card__arrival__see_accommodation_zone(inputs)
	if (locale === "nl") return nl_zoi_card__arrival__see_accommodation_zone(inputs)
	return pt_zoi_card__arrival__see_accommodation_zone(inputs)
};